/**
 * Created by lakshan on 6/6/17.
 */
(function() {
  'use strict';

  /**
   * @ngdoc factory
   * @name messageAdmin.factory:MessageAdminFactory
   *
   * @description
   *
   */
  angular.module('messageAdmin').factory('MessageAdminFactory', MessageAdminFactory);

  function MessageAdminFactory() {

    // ----declare DTOs------
    function MessageAdminSearchRequest() {
      this.fromDate = null;
      this.toDate = null;
      this.category = null;
      this.crewType = null;
      this.status = null;
      this.sentBy = null;
      this.sentByUserId = null;
      this.profileId = null;
      this.startPosition = 1;
      this.pageSize = 100000;
    }

    function MessageDetailDTO() {
      this.messageId = null;
      this.index = null;
      this.title = null;
      this.category = null;
      this.sentBy = null;
      this.dateSent = null;
      this.readCount = null;
      this.replies = null;
      this.priority = null;
      this.status = null;
      this.readByAll = null;
    }

    function EditMessageDTO(){
      this.messageId = null;
      this.attachments = [];
      this.title = null;
      this.content = null;
      this.categoryCode = { messageCategoryCode : null};
      this.msgPriority = null;
      this.crewType = null;
      this.crewProfileIds = [];
      this.receivers = [];
      this.assignedCrew = [];
      this.version = null;
      this.isSentMsg = false;
      this.isResendOrForwardBtnClick = false;
    }

    function EditMessageReceiversDTO(){
      this.receivedBy = null;
      this.dateRead = null;
      this.dateViewed = null;
      this.readStatus = null;
      this.crewProfileId = null;
    }

    function EditMessageAssignedCrewDTO(){
      this.crewProfileId = null;
      this.displayName = null;
    }

    function MessageDeleteRequest() {
      this.messageId = null;
    }

    function MessageAdminSaveRequest(){
    	// mandatory fields
    	this.title = null;
    	this.content = null;
    	this.categoryCode = null;
    	this.msgPriority = null;
    	this.send = false;
    	this.reSendOrForward = false;

    	// other fields
    	this.messageId = null;
    	this.version = null;
    	this.crewProfileIds = null;

    	this.sendBy = null;
    	this.isReply = null;
    	this.parentMessageId = null;
    	this.originalMessageId = null;

    	this.messageUserId = null;
    	this.messageUserVersion = null;
    }

    // ----Define Function --------
    function GetMessageAdminSearchRequest() {
      return new MessageAdminSearchRequest();
    }

    // getter and setter of message delete request
    function GetMessageDeleteRequest() {
      return new MessageDeleteRequest();
    }

    function GetFormattedMessageDeleteRequest(
      selectedMessage) {
      var deleteReq = new MessageDeleteRequest();
      if (!!selectedMessage) {
        deleteReq.messageId = selectedMessage.messageId;
      }
      return deleteReq;
    }

    function GetFormattedMessageAdminSearchRequest(searchCriteria) {
      var searchReq = new MessageAdminSearchRequest();
      searchReq.fromDate = searchCriteria.fromDate;
      searchReq.toDate = searchCriteria.toDate;
      if (!!searchCriteria.category && !! searchCriteria.category.messageCategoryCode) {
          searchReq.category = searchCriteria.category.messageCategoryCode;
      }
      if (!!searchCriteria.crewType && !! searchCriteria.crewType.crewTypeCode) {
        searchReq.crewType = searchCriteria.crewType.crewTypeCode;
      }
      if (!!searchCriteria.status && !! searchCriteria.status.status) {
        searchReq.status = searchCriteria.status.status;
      }
      if (!!searchCriteria.sentBy && !! searchCriteria.sentBy.value) {
        searchReq.sentBy = searchCriteria.sentBy.value;//sentBy = "Crew" or "Non Crew"
        //if sentBy = "Crew"
        if (searchReq.sentBy === "CREW") {
            if(!!searchCriteria.userName && !!searchCriteria.userName.crewProfileId){
            	searchReq.profileId = searchCriteria.userName.crewProfileId;
            }
        }else if(!!searchCriteria.userName && !!searchCriteria.userName.crewId){
        	searchReq.sentByUserId = searchCriteria.userName.crewId;
        }
      }
      return searchReq;
    }

    function GetNewEditMessage(){
    	return new EditMessageDTO();
    }

    function GetFormattedEditMessage(message){
      var editMessage = new EditMessageDTO();
      editMessage.messageId = message.messageId;
      editMessage.attachments = message.attachments;
      editMessage.title = message.title;
      editMessage.content = message.content;
      editMessage.categoryCode = message.categoryCode;
      editMessage.crewType = null;
      editMessage.msgPriority = message.msgPriority;
      editMessage.version = message.version;

      if(message.messageStatus === "DRAFT"){
        editMessage.crewProfileIds = message.msgUserProfileIds;
        editMessage.isSentMsg = false;
      }
      else{ //SENT
    	editMessage.crewProfileIds = null;
    	editMessage.isSentMsg = true;
        if (!!message.messageUsers && message.messageUsers.length > 0) {
          for (var i = 0; i < message.messageUsers.length; i++) {
            var aReceiver = new EditMessageReceiversDTO();
            aReceiver.receivedBy = message.messageUsers[i].userName;
            aReceiver.dateRead = message.messageUsers[i].msgReadDate;
            aReceiver.dateViewed = message.messageUsers[i].msgViewedDate;
            aReceiver.readStatus = message.messageUsers[i].msgRead;
            aReceiver.crewProfileId = message.messageUsers[i].crewProfileId;
            editMessage.receivers.push(aReceiver);
          }
        }
      }
      return editMessage;
    }

    function GetFormattedMessageList(messages, categoryList){
    	var messageList = [];
    	if(!!messages && messages.length > 0){
    		for (var i = 0; i < messages.length; i++){
    			messages[i].categoryDesc = _.find(categoryList, {
    		          messageCategoryCode : messages[i].categoryCode
    	        }).messageTypeDescription;
    			messageList.push(messages[i]);
    		}
    	}
    	return messageList;
    };

    function SetSelectedFlag(crewList){
    	if(!!crewList){
    		crewList.forEach(function(crew) {
    			crew.isSelected = false;
    			crew.isRemoved = false;
    			crew.hide = false;
    		});
    	}
    	return crewList;
    }

    function GetMessageAdminSaveRequest(){
    	return new MessageAdminSaveRequest();
    }

    function GetMessageAdminFormattedSaveRequest(sendMsg){
    	var saveRq = new MessageAdminSaveRequest();

    	// mandatory fields
    	saveRq.title = sendMsg.title;
    	saveRq.content = sendMsg.content;
    	saveRq.categoryCode = sendMsg.categoryCode.messageCategoryCode;
    	saveRq.msgPriority = sendMsg.msgPriority.value;
    	saveRq.send = sendMsg.isSend;
    	saveRq.reSendOrForward = false;

    	// other fields
    	if(!!sendMsg.messageId){
    		saveRq.messageId = sendMsg.messageId;
    		saveRq.version = sendMsg.version;
    	}
    	if(!!sendMsg.crewProfileIds){
    		saveRq.crewProfileIds = sendMsg.crewProfileIds;
    	}
    	if(!!sendMsg.sendBy){
    		saveRq.sendBy = sendMsg.sendBy;
    	}


    	if(!!sendMsg.isReply){
    		saveRq.isReply = sendMsg.isReply;
    	}
    	if(!!sendMsg.parentMessageId){
    		saveRq.parentMessageId = sendMsg.parentMessageId;
    	}
    	if(!!sendMsg.originalMessageId){
    		saveRq.originalMessageId = sendMsg.originalMessageId;
    	}
    	if(!!sendMsg.messageUserId){
    		saveRq.messageUserId = sendMsg.messageUserId;
    	}
    	if(!!sendMsg.messageUserVersion){
    		saveRq.messageUserVersion = sendMsg.messageUserVersion;
    	}
    	return saveRq;
    }

    // map services to return
    return {
      getMessageAdminSearchRequest : GetMessageAdminSearchRequest,
      getFormattedMessageAdminSearchRequest : GetFormattedMessageAdminSearchRequest,
      getFormattedEditMessage : GetFormattedEditMessage,
      getMessageDeleteRequest : GetMessageDeleteRequest,
      getFormattedMessageDeleteRequest : GetFormattedMessageDeleteRequest,
      getFormattedMessageList : GetFormattedMessageList,
      getNewEditMessage : GetNewEditMessage,
      setSelectedFlag : SetSelectedFlag,
      getMessageAdminSaveRequest : GetMessageAdminSaveRequest,
      getMessageAdminFormattedSaveRequest : GetMessageAdminFormattedSaveRequest,
    }

  }
})();
